<script setup lang="ts">
import {onMounted, onUnmounted, ref, watch} from "vue";
import "@/assets/styles/main.css"
import {useRoute} from "vue-router";

const route = useRoute();

watch(
    () => route.meta.title,
    (title) => {
      document.title = title as string || "Butterweck Digital";
    }
);

const isMobile = ref(window.innerWidth <= 1600);

const handleResize = () => {
  isMobile.value = window.innerWidth <= 1600;
};

onMounted(() => window.addEventListener("resize", handleResize));
onUnmounted(() => window.removeEventListener("resize", handleResize));

</script>

<template>
  <router-view/>
</template>
